<template>
    <FormSection
        title="Admission Source and Timing (PDGM)"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template v-slot:content>
            <section class="row py-3 pb-0 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center field-title">
                        <span class="badge me-1">M1000</span> From which of the following
                        <b class="ms-1 me-1">Inpatient Facilities </b> was the patient discharged within the past 14
                        days?(Mark all that apply) <span class="text-danger">*</span>
                    </p>
                    <div
                        :class="`${
                            v$.referral.Demographics.AdmissionSources.$error ||
                            errors.Demographics.includes('AdmissionSources')
                                ? 'border border-warning p-2 rounded'
                                : ''
                        }`"
                    >
                        <div v-for="option of admissionOptionsToDisplay" :key="`${option.value}-${option.label}`">
                            <div class="form-check custom-checkbox pb-1 ms-2" v-if="showCheckbox(option)">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="`${option.value}-${option.label}`"
                                    :value="option.value"
                                    :checked="isAdmissionSourceChecked(option)"
                                    @change="handleAdmissionSource(option.value)"
                                    @blur="v$.referral.Demographics.AdmissionSources.$touch"
                                />
                                <label class="form-check-label" :for="`${option.value}-${option.label}`">
                                    <small>{{ option.label }} </small>
                                </label>
                            </div>
                            <template v-if="showOtherAdmissionSource && option.value === 64">
                                <div class="d-flex bg-white flex-column ms-4 w-40 pb-4">
                                    <label class="service-required-text-color">Other Admission Source </label>
                                    <input
                                        type="text"
                                        class="form-control w-90"
                                        placeholder="Enter Admission Source"
                                        v-model="referral.Demographics.AdmissionSourceOther"
                                        maxlength="300"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0 mt-3">
                    <p class="mb-2 d-flex align-items-center">
                        <span class="badge me-1">M0110</span> <b>Episode Timing</b> <span class="text-danger">*</span>
                    </p>
                    <p class="field-title">
                        Is the Medicare home health episode, for which this assessment will define a case-mix group, an
                        "early" episode or a "later" episode in the patient's current sequence of adjacent Medicare home
                        health payment episodes?
                    </p>
                    <div
                        :class="`${
                            v$.referral.Demographics.EpisodeTiming.$error ||
                            errors.Demographics.includes('EpisodeTiming')
                                ? 'border border-warning p-2 rounded'
                                : ''
                        }`"
                    >
                        <div
                            v-for="option of episodeTiming"
                            class="form-check ms-2 pb-1"
                            :key="`${option.value}-${option.label}`"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                :id="`${option.value}-${option.label}`"
                                :value="option.value"
                                :checked="option.value === referral.Demographics.EpisodeTiming"
                                @click="handleEpisodeTimingChange(option.value)"
                                @blur="v$.referral.Demographics.EpisodeTiming.$touch"
                            />
                            <label class="form-check-label mb-2" :for="`${option.value}-${option.label}`">
                                <small>{{ option.label }}</small></label
                            >
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./AdmissionSource.ts"></script>
